<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large" type="primary">
			提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue'
	import wx from 'weixin-js-sdk'
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import stringUtils from "../assets/js/stringUtil.js";
    import { apprenticeFill, getApprentNumber, getCheckApprentNumber } from '../api/MentoringRelationship'
	import { getTemplateInfo, submitProcess } from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading: false,
				apprentices: [],
				// 徒弟上限
				apprenticeMaxNum: 0,
				// 现有徒弟数
				apprenticeNum: 0,
				//现有徒弟员编集合
				apprenticesNos:[]
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			clickChoose: async function (dataVal, name) {
				var that = this;
				window.wx.invoke(
					"selectEnterpriseContact", {
					fromDepartmentId: -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					mode: "multi", // 必填，选择模式，single表示单选，multi表示多选
					type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				},
					async function (res) {
						if (res.err_msg === "selectEnterpriseContact:ok") {
							if (typeof res.result == "string") {
								res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
							}
							const users = res.result.userList;
							if (users.length > (that.apprenticeMaxNum - that.apprenticeNum)) {
								dataVal.Values = []
								dataVal.Value = "";
								that.Message({
									message: '徒弟数已超过最大限制',
									type: 'error',
									duration: 3000
								});
								return
							}
							let resultStr = '';
							dataVal.Values = [];
							that.apprentices = [];
							users.forEach((user, index) => {
								/*let aa = that.apprenticesNos.find(c => c == user.id);*/
                                if (index === users.length - 1) {
                                    resultStr += `${user.name}`
                                } else {
                                    resultStr += `${user.name},`
                                }
                                dataVal.Values.push([user.id, user.name]);
							})

                            let empNos = []
                            users.forEach((e, i) => {
                                empNos.push(e.id)
							})
							
							let aa = empNos.find(c => c == that.logInfo.EmpNo);
                            if (aa) {
                                that.Message({
                                    type: 'error',
                                    message: '师傅不允许申请自己为徒弟！',
                                    duration: 3000
                                });
								dataVal.Values = [];
								that.apprentices = [];
                                return;
                            }
                            await getCheckApprentNumber(empNos).then( response => {
								if (response.Body) {
									that.apprentices = empNos;
								}
							},err => {
                                dataVal.Values = [];
                                that.apprentices = [];
                                resultStr = '';
                                return;
                            })
							dataVal.Value = resultStr;
						}
					}
				);
			},
			getTemplate: async function () {
				const that = this
				this.listLoading = true;
				const { EmpNo, DeptName, EmpName } = this.logInfo
				//获取当前徒弟数量
				const apprentNumber = await getApprentNumber(EmpNo)
			
				 const body = apprentNumber.Body
				 that.apprenticeNum = body.ApprenticesNum
				that.apprenticeMaxNum = body.ApprenticesLimitNum
				that.apprenticesNos = body.ApprenticesNos
               
				const up = await this.getEmployeeRelation()
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(item => {
						const name = item.Property.Title[0].Text
						switch (name) {
							case "申请人部门":
								item.Value = DeptName
								item.Disable = true
								break
							case "申请人姓名":
								item.Value = EmpName
								item.Disable = true
								break
							case "申请人工号":
								item.Value = EmpNo
								item.Disable = true
								break
							case "当前徒弟数量":
								item.Value = that.apprenticeNum
								item.Disable = true
								break
              case "逐级审批使用":
                item.Values = that.getRelationList(that.relationList, 8);
                if (item.Values.length === 0) {
                  item.Values = [that.$store.state.defaultMember]
                }
                item.Disable = true
                item.IsShow = false
						}
					})
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
					this.listLoading = false;
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() { },
			getSelectorVal(val, name, datas) {
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				console.log(1)
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				console.log(2)
				if (this.apprentices.length <= 0) {
                    this.Message({
                        message: '未添加有效人员',
                        type: 'error',
                        duration: 3 * 1000
                    });
                    return;
                }
				const addRequest = {
					masterNo: this.logInfo.EmpNo,
					apprentices: this.apprentices,
					spNo: ""
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.formLoading = true;

				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];

				            var control1 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "申请人姓名"})[0]
				            var control2 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "申请人工号"})[0]
				            var control3 = this.templateData.TemplateContent.Controls.filter(t => { return t.Property.Title[0].Text == "申请人部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo = [];
				info.SummaryInfo.push({"Text":"申请人信息："+" "+control1.Value+" "+control2.Value+" "+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList = SummaryList;

				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData, this.flowId).then(response => {
					
                    this.Message({
                        message: '申请成功',
                        type: 'success',
                        duration: 3 * 1000
                    });
                    addRequest.spNo = response.Body.SpNo
					// 保存徒弟

					apprenticeFill(addRequest)
					setTimeout(() => { this.$router.push("/index"); }, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		},
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
